<template lang="html">
    <el-alert
      style="cursor:pointer"
      v-show="show"
      :title="title"
      type="success"
      center
    >
    </el-alert>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      notice: 'notice'
    })
  },
  watch: {
    'notice.newPkg': function (val) {
      if (val.length > 0) {
        var num = 0
        for (var i = 0; i < val.length; i++) {
          if (val[i] === localStorage.getItem('projectId')) {
            this.show = true
            num = num + 1
          }
        }
        if (num === 0) {
          this.show = false
          return
        }
        this.title = this.$lang.ui.notice.l120.l0 + num + this.$lang.ui.notice.l120.l1
      } else {
        this.show = false
      }
    }
  },
  data () {
    return {
      show: false,
      title: ''
    }
  }
}
</script>

<style lang="css">
.el-alert {
  margin-top: 10px;
}
</style>
